import type { ChangeEvent, ReactNode, RefObject } from "react";
// import { SignatureModal } from "../../../components/Form/SignatureModel";
// import { AttachmentSection } from "../../../components/Form/AttachmentSection";
import type { LegalAdviceFormSevenAData } from "../../../types/LegalAdvices/LegalAdviceFormSevenA.type";
import { DatalistInput } from "../components/dataListInput";
// import { FormActionButtons } from "../../../components/Form/FormActionButton";
import { useSettings } from "../../../context/SettingContext";


export interface AttachmentFile {
  name: string;
  [key: string]: any;
}

export interface DetailFormDocumentProps {
  formData: LegalAdviceFormSevenAData;
  isEditable: boolean;
  isSigning: boolean;
  sigCanvasRef: RefObject<any>;
  setIsSigning: (isSigning: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveSignature: () => void;
  renderDocumentRow: (label: string, fieldName: any) => ReactNode;
  renderDatePicker: (fieldName: any) => ReactNode;

  // Additional props required for action controls inside this component
  isPreview?: boolean;
  // isSubmitting?: boolean;
  // isApproved?: boolean;
  handleBackNavigation: () => void;
  // handleSaveDraft: (e: React.MouseEvent) => void;
  // handleSubmitToSuperior: (e: React.MouseEvent) => void;
 // handleAttachment:(e:React.MouseEvent)=> void;
}

export const LegalDetailFormSevenADocument: React.FC<DetailFormDocumentProps> = ({
  formData,
//   isSigning,
//   sigCanvasRef,
//   setIsSigning,
  handleChange,
//   handleSaveSignature,
  renderDatePicker,
  // isApproved,
  // isSubmitting = false,
  // handleBackNavigation,
  // handleSaveDraft,
  // handleSubmitToSuperior,
  // handleAttachment
}) => {
  // Replace these with your actual option data sources or imports
 const { settings } = useSettings();

//  const isFormSigned = Boolean(
//     formData.signatureImage?.trim() && 
//     (formData.signerName?.trim() || formData.signName?.trim())
//   );

// Map to simple string arrays for your dropdowns/datalists
const OFFICE_OPTIONS = settings?.offices.map((o) => o.name) || [];
// const TOWNSHIP_OPTIONS = settings?.townships.map((t) => t.name) || [];


  return (
        <div className="w-full max-w-[850px] bg-white shadow-lg border border-gray-300 p-12 text-black space-y-16 text-xs md:text-sm leading-relaxed">
                
                {/* ==================== စာမျက်နှာ ၁ ==================== */}
                <div>
                  <div className="text-right text-xs font-bold">ဥပရအမှုလိုက်ပုံစံ (၇-က)</div>
                  
                  <div className="text-center space-y-2 mt-2">
                    <h1 className="text-base font-bold">ပြည်ထောင်စုသမ္မတမြန်မာနိုင်ငံတော်အစိုးရ</h1>
                    <h2 className="text-sm font-bold">ပြည်ထောင်စုရှေ့နေချုပ်ရုံး</h2>
                    <div className="flex justify-center items-center gap-2">
                      <DatalistInput
                        name="office"
                        value={formData.office}
                        onChange={handleChange}
                        placeholder=""
                        options={OFFICE_OPTIONS}
                      />
                      <span className="font-bold">ရုံး</span>
                    </div>
                    <h3 className="text-sm font-bold pt-4 max-w-2xl mx-auto leading-normal">
                      အပြီးအပြတ်လွတ်သည့်အမိန့်အား အယူခံမှုကို ပလပ်သည့် အမိန့်အပေါ် အယူခံမှု တင်သွင်းရန် သင့် မသင့် စိစစ်တင်ပြခြင်း
                    </h3>
                  </div>
        
                  {/* အမှတ်စဉ် ၁ မှ ၁၆ */}
                  <div className="mt-8 space-y-4">
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၁။</span>
                      <span className="flex-1">ဥပဒေရုံး၏ အယူခံမှုတင်သွင်းရန် သင့်မသင့် စိစစ်ခြင်း မှတ်ပုံတင်အမှတ်စဉ်</span>
                      <input type="text" name="registerNo" value={formData.registerNo} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၂။</span>
                      <span className="flex-1">အမှုလိုက်စာတွဲအမှတ်</span>
                      <input type="text" name="adviceCaseNo" value={formData.adviceCaseNo} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၃။</span>
                      <span className="flex-1">မူလတရားရုံးအမည်နှင့် အမှုအမှတ်</span>
                      <input type="text" name="originalCourtAndCaseNo" value={formData.originalCourtAndCaseNo} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၄။</span>
                      <span className="flex-1">တရားစွဲဆိုထားသည့်ဥပဒေ၊ ပုဒ်မ</span>
                      <input type="text" name="prosecutedLawSection" value={formData.prosecutedLawSection} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၅။</span>
                      <span className="flex-1">စွဲချက်တင်သည့် ဥပဒေ၊ ပုဒ်မ</span>
                      <input type="text" name="chargedLawSection" value={formData.chargedLawSection} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၆။</span>
                      <span className="flex-1">အယူခံ၊ ပြင်ဆင်တရားရုံးအမည်နှင့် အမှုအမှတ်</span>
                      <input type="text" name="appealCourtAndCaseNo" value={formData.appealCourtAndCaseNo} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၇။</span>
                      <span className="flex-1">အပြီးအပြတ်လွတ်သည့် အမိန့်ချမှတ်သည့်ရက်စွဲ</span>
                      <input type="text" name="acquittalDate" value={formData.acquittalDate} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၈။</span>
                      <span className="flex-1">တိုင်းဒေသကြီး / ပြည်နယ်တရားလွှတ်တော်အမည်နှင့် အမှုအမှတ်</span>
                      <input type="text" name="regionStateCourtAndCaseNo" value={formData.regionStateCourtAndCaseNo} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၉။</span>
                      <span className="flex-1">အပြီးအပြတ်လွတ်သည့်အမိန့်အား အယူခံမှုကို ပလပ်သည့် အမိန့်ချမှတ်သည့် ရက်စွဲ</span>
                      <div className="w-1/3 flex-grow px-2 text-center">{renderDatePicker('dismissalOrderDate')}</div>
                      {/* <input type="text" name="dismissalOrderDate" value={formData.dismissalOrderDate} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" /> */}
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၁၀။</span>
                      <span className="flex-1">အယူခံမှုတင်သွင်းရန် တင်ပြလျှောက်ထားသူ</span>
                      <input type="text" name="submitterName" value={formData.submitterName} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၁၁။</span>
                      <span className="flex-1">အယူခံမှုတင်သွင်းရန်လျှောက်လွှာ / အကြောင်းကြားစာ ရရှိသည့်ရက်စွဲ (ရှိလျှင်)</span>
                        <div className="w-1/3 flex-grow px-2 text-center">{renderDatePicker('applicationLetterDate')}</div>
                      {/* <input type="text" name="applicationLetterDate" value={formData.applicationLetterDate} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" /> */}
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၁၂။</span>
                      <span className="flex-1">စီရင်ချက်မိတ္တူလျှောက်ထားသည့်ရက်စွဲ</span>
                      <input type="text" name="judgmentCopyApplyDate" value={formData.judgmentCopyApplyDate} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၁၃။</span>
                      <span className="flex-1">စီရင်ချက်မိတ္တူရရှိသည့်ရက်စွဲ</span>
                        <div className="w-1/3 flex-grow px-2 text-center">{renderDatePicker('judgmentCopyReceiveDate')}</div>
                      {/* <input type="text" name="judgmentCopyReceiveDate" value={formData.judgmentCopyReceiveDate} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" /> */}
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၁၄။</span>
                      <span className="flex-1">အယူခံမှုတင်သွင်းရန် သင့် မသင့် စိစစ်ချက်တင်ပြရမည့်ရက်စွဲ</span>
                        <div className="w-1/3 flex-grow px-2 text-center">{renderDatePicker('reviewSubmitDeadline')}</div>
                      {/* <input type="text" name="reviewSubmitDeadline" value={formData.reviewSubmitDeadline} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" /> */}
                    </div>
        
                    <div className="flex items-baseline">
                      <span className="w-10 font-bold">၁၅။</span>
                      <span className="flex-1">အယူခံမှုတင်သွင်းရန် သင့် မသင့် စိစစ်ချက်တင်ပြသည့်ရက်စွဲ</span>
                        <div className="w-1/3 flex-grow px-2 text-center">{renderDatePicker('reviewSubmitDate')}</div>
                      <input type="text" name="reviewSubmitDate" value={formData.reviewSubmitDate} onChange={handleChange} className="w-1/3 bg-transparent border-b border-dotted border-black focus:outline-none px-2 text-center" />
                    </div>
        
                    <div className="flex flex-col space-y-1">
                      <div className="flex items-baseline">
                        <span className="w-10 font-bold">၁၆။</span>
                        <span className="flex-1">အယူခံမှုတင်သွင်းရန် လျှောက်ထားခံရသူ (များ)၏ အမည်၊ အဘအမည်၊ အကျဥ်းသားနံပါတ်၊အကျဥ်းထောင်အမည်နှင့်နောက်ဆုံး နေရပ်လိပ်စာအပြည့်အစုံ -</span>
                      </div>
                      <textarea
                        name="respondentDetails"
                        value={formData.respondentDetails}
                        onChange={handleChange}
                        rows={4}
                        className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1"
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>
        
                <hr className="border-gray-300" />
        
                {/* ==================== စာမျက်နှာ ၂ ==================== */}
                <div className="space-y-6">
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">၁၇။</span>အမှုဖြစ်စဉ်အကျဉ်း</label>
                    <textarea name="caseSummary" value={formData.caseSummary} onChange={handleChange} rows={5} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                  </div>
        
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">၁၈။</span>တရားလိုဘက်မှ သက်သေများ၏ ထွက်ဆိုချက်များ</label>
                    <p className="text-gray-500 text-xs pb-1">တရားလိုနှင့် တရားလိုပြသက်သေတစ်ဦးစီ၏ အရေးပါသောထွက်ဆိုချက် (ပြန်လှန်စစ်ဆေးရာတွင် ပျက်ပြယ်သွားခြင်း ရှိ မရှိ ဖော်ပြရန်)</p>
                    <textarea name="prosecutionWitnessStatements" value={formData.prosecutionWitnessStatements} onChange={handleChange} rows={5} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                  </div>
        
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">၁၉။</span>တရားခံဘက်မှ သက်သေများ၏ ထွက်ဆိုချက်များ</label>
                    <p className="text-gray-500 text-xs pb-1">တရားခံနှင့် တရားခံပြသက်သေတစ်ဦးစီ၏ အရေးပါသောထွက်ဆိုချက် အကျဉ်းနှင့် (တရားခံတင်ပြသည့် သက်သေခံ အထောက်အထားများ (ရှိလျှင်) ဖော်ပြရန်)</p>
                    <textarea name="defenseWitnessStatements" value={formData.defenseWitnessStatements} onChange={handleChange} rows={5} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                  </div>
        
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">၂၀။</span>ရုံးခေါ်သက်သေ (ရှိလျှင်) ၏ ထွက်ဆိုချက်များ</label>
                    <textarea name="courtWitnessStatements" value={formData.courtWitnessStatements} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                  </div>
        
                  <div className="space-y-3">
                    <label className="font-bold"><span className="mr-4">၂၁။</span>အမှုလိုက်ဥပဒေအရာရှိ၏ သုံးသပ်ချက်</label>
                    <div className="pl-6 space-y-2">
                      <div className="flex flex-col space-y-1">
                        <span className="font-medium">(က) တရားလိုဘက်မှ တင်ပြချက်များအပေါ် သုံးသပ်ချက်</span>
                        <textarea name="advocateOpinionProsecution" value={formData.advocateOpinionProsecution} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                      </div>
                      <div className="flex flex-col space-y-1">
                        <span className="font-medium">(ခ) တရားခံဘက်မှ တင်ပြချက်များအပေါ် သုံးသပ်ချက်</span>
                        <textarea name="advocateOpinionDefense" value={formData.advocateOpinionDefense} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                      </div>
                      <div className="flex flex-col space-y-1">
                        <span className="font-medium">(ဂ) သက်သေခံပစ္စည်းနှင့် သက်သေခံစာရွက်စာတမ်းများအပေါ် သုံးသပ်ချက်</span>
                        <textarea name="exhibitsReview" value={formData.exhibitsReview} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                      </div>
                    </div>
                  </div>
                </div>
        
                <hr className="border-gray-300" />
        
                {/* ==================== စာမျက်နှာ ၃ ==================== */}
                <div className="space-y-6">
                  <div className="space-y-3">
                    <label className="font-bold"><span className="mr-4">(ဃ)</span>တရားရုံး၏ စီရင်ချက်နှင့် စပ်လျဉ်း၍ သုံးသပ်ချက်</label>
                    <div className="pl-6 space-y-3">
                      <div className="flex flex-col space-y-1">
                        <span className="font-medium">(၁) မူလတရားရုံး စီရင်ချက်နှင့်စပ်လျဉ်း၍ သုံးသပ်ချက်</span>
                        <textarea name="courtJudgmentReviewOriginal" value={formData.courtJudgmentReviewOriginal} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                      </div>
                      <div className="flex flex-col space-y-1">
                        <span className="font-medium">(၂) အယူခံ၊ ပြင်ဆင်တရားရုံး စီရင်ချက်နှင့်စပ်လျဉ်း၍ သုံးသပ်ချက်</span>
                        <textarea name="courtJudgmentReviewAppeal" value={formData.courtJudgmentReviewAppeal} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                      </div>
                      <div className="flex flex-col space-y-1">
                        <span className="font-medium">(၃) တိုင်းဒေသကြီး သို့မဟုတ် တရားလွှတ်တော် စီရင်ချက်နှင့်စပ်လျဉ်း၍ သုံးသပ်ချက်</span>
                        <textarea name="courtJudgmentReviewHighCourt" value={formData.courtJudgmentReviewHighCourt} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                      </div>
                    </div>
                  </div>
        
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">(င)</span>အယူခံမှုတင်သွင်းရန် သင့်မသင့် သုံးသပ်တင်ပြချက်</label>
                    <textarea name="appealFitnessOpinion" value={formData.appealFitnessOpinion} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                  </div>                  
                </div>

                {/* ==================== စာမျက်နှာ ၃ ==================== */}
        <div className="space-y-6">
          <div className="flex flex-col items-end pt-4">
            <div className="w-72 space-y-2">
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">လက်မှတ်</span>
                <div 
                // onClick={() => handleOpenSignatureModel('handling')} 
                className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                  {formData.handlingSignatureImage ? (
                    <img src={formData.handlingSignatureImage} alt="Region Sign" className="h-8 object-contain" />
                  ) : (
                    <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                  )}
                  {formData.handlingSignatureImage && (
                    <button
                      type="button"
                      // onClick={handleClearHandlingSignature}
                      title="လက်မှတ်ရှင်းလင်းမည်"
                      className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
              <div className="flex items-center">
                <span className="w-32 text-right text-xs mr-2">အမည်</span>
                <input type="text" name="handlingSignName" value={formData.handlingSignName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
              </div>
              <div className="text-center text-xs font-bold pt-1">အမှုလိုက်ဥပဒေအရာရှိ</div>
              <div className="flex items-center">
                <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                <div className="flex-grow">{renderDatePicker('handlingSubmitDate')}</div>
              </div>
            </div>
          </div>

        </div>
                
                {/* ==================== စာမျက်နှာ ၄ ==================== */}
                <div className="space-y-4">
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">၂၂။</span>အယူခံမှုတင်သွင်းရန် သင့် မသင့်နှင့် စပ်လျဉ်း၍ နှစ်ဖက် သက်သေခံချက် (များ)၊ တရားရုံး (များ)၏ စီရင်ချက် (များ)အပေါ် သုံးသပ်တင်ပြချက်</label>
                    <textarea name="centralOfficerOpinion" value={formData.centralOfficerOpinion} onChange={handleChange} rows={5} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                  </div>
        
                  {/* ဗဟိုအဆင့် တာဝန်ခံဥပဒေအရာရှိ လက်မှတ် */}
                  <div className="flex flex-col items-end pt-4">
                    <div className="w-72 space-y-2">
                      <div className="flex items-center">
                        <span className="w-32 text-right text-xs mr-2">လက်မှတ်</span>
                        <div
                        //  onClick={() => handleOpenSignatureModel('central')}
                          className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                          {formData.centralOfficerSignatureImage ? (
                            <img src={formData.centralOfficerSignatureImage} alt="Central Sign" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {formData.centralOfficerSignatureImage && (
                            <button
                              type="button"
                            //   onClick={handleClearCentralOfficerSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-32 text-right text-xs mr-2">အမည်</span>
                        <input type="text" name="centralOfficerSignName" value={formData.centralOfficerSignName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                      </div>
                      <div className="text-center text-xs font-bold pt-1">တာဝန်ခံဥပဒေအရာရှိ</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">လက်ခံရရှိသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('centralOfficerReceiveDate')}</div>
                        {/* <input type="text" name="centralOfficerReceiveDate" value={formData.centralOfficerReceiveDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
                      </div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('centralOfficerSubmitDate')}</div>
                        {/* <input type="text" name="centralOfficerSubmitDate" value={formData.centralOfficerSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
                      </div>
                    </div>
                  </div>
                </div>

                 {/* ==================== စာမျက်နှာ ၁၃၅ ==================== */}
                <div className="space-y-4">
                  <div className="flex flex-col space-y-1">
                    <label className="font-bold"><span className="mr-4">၂၃။</span>အယူခံမှုတင်သွင်းရန် သင့် မသင့်နှင့် စပ်လျဉ်း၍ သုံးသပ်တင်ပြချက်</label>
                    <textarea name="centralOfficerOpinion" value={formData.centralOfficerOpinion} onChange={handleChange} rows={5} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none" />
                  </div>

                  {/* တိုင်းဒေသကြီး/ပြည်နယ် ဥပဒေချုပ် လက်မှတ် */}
                  <div className="flex flex-col items-end pt-4">
                    <div className="w-72 space-y-2">
                      <div className="flex items-center">
                        <span className="w-32 text-right text-xs mr-2">လက်မှတ်</span>
                        <div 
                        // onClick={() => handleOpenSignatureModel('region')} 
                        className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                          {formData.regionSignatureImage ? (
                            <img src={formData.regionSignatureImage} alt="Region Sign" className="h-8 object-contain" />
                          ) : (
                            <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                          )}
                          {formData.regionSignatureImage && (
                            <button
                              type="button"
                              // onClick={handleClearRegionSignature}
                              title="လက်မှတ်ရှင်းလင်းမည်"
                              className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <span className="w-32 text-right text-xs mr-2">အမည်</span>
                        <input type="text" name="regionSignName" value={formData.regionSignName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                      </div>
                      <div className="text-center text-xs font-bold pt-1">တိုင်းဒေသကြီး / ပြည်နယ်ဥပဒေချုပ်</div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">လက်ခံရရှိသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('regionReceiveDate')}</div>
                        {/* <input type="text" name="regionReceiveDate" value={formData.regionReceiveDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
                      </div>
                      <div className="flex items-center">
                        <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                        <div className="flex-grow">{renderDatePicker('regionSubmitDate')}</div>
                        {/* <input type="text" name="regionSubmitDate" value={formData.regionSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" /> */}
                      </div>
                    </div>
                  </div>

                  <div className="text-xs text-gray-500 italic mt-4 pt-2">
                    မှတ်ချက်။ ။ ဤပုံစံပါအမှတ်စဉ် ၁၆ မှ ၂၃ ထိ အချက်အလက်များကို စာရွက်လွတ်ဖြင့် ဖြည့်သွင်းရေးသားပြီး အစဉ်အတိုင်း ပူးတွဲတင်ပြရန်ဖြစ်ပါသည်။
                  </div>
                </div>
        
              
                {/* <div className="absolute bottom-4 left-4 text-xs text-gray-400 print:bottom-0 print:left-0">
                  လျှို့ဝှက်
                </div> */}

        
              </div>
  );
};